import { Injectable } from '@angular/core';
import { DateAdapter, MatDateFormats } from '@angular/material/core';
import moment from "moment";
import 'moment/locale/fr';

@Injectable({
  providedIn: 'root',
})
export class MpsDateFormatService {

  private formats: { [key: string]: MatDateFormats } = {
    "en-GB": {
      parse: {
        dateInput: 'DD/MM/YYYY',
      },
      display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    },
    "fr-FR": {
      parse: {
        dateInput: 'DD/MM/YYYY',
      },
      display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    },
  };

  constructor(private dateAdapter: DateAdapter<any>) {}

  setLocale(lang: string): void {
    moment.locale(lang);
    this.dateAdapter.setLocale(lang);
  }

  getFormats(lang: string) {
    return this.formats[lang] || this.formats['en-GB'];
  }
}
